<template>
    <div>
        <Form
            :tipoExameId="tipoExameId"
            :itens="itens"
        />

        <rkm-area title="Exames">
            <List :itens="itens" />
        </rkm-area>
    </div>
</template>

<script>
import Form from './Form'
import List from './List'

export default {
    components: { Form, List },
    props: {
        tipoExameId: { type: Number },
        itens: { type: Array, default: () => [] }
    },
}
</script>